import React, { Component } from 'react'
import styled from 'styled-components'
import TimelineCarousel from '../components/TimelineCarousel'
import TimelineYearDetails from '../components/TimelineYearDetails'
import bgImage from '../static/images/backgrounds/timeline.jpg'
import mobBgImage from '../static/images/backgrounds/timeline_m.png'
import { media, colors } from '../styles/vars'
import { Title, Subtitle } from '../styles/elements'
import { TimelineApi } from '../api'
import clockHead from '../static/images/objects/circle.png'
import clockHand from '../static/images/objects/clock_hand.png'
import shapeSrc from '../static/images/backgrounds/upper_timeline_shape.png'
import { push } from '../analytics'
import { Section } from '../styles/elements'

const Container = styled(Section) `
background-color:#312f30;
position:relative;
text-align:center;
padding:40px 0;
${
    media.desktop`
    background-repeat:no-repeat;
    background-image:url(${bgImage});
    background-position:bottom right;
    background-size:cover;
    &:after{
        content:'';
        position:absolute;
        top:0;
        right:0;
        height:300px;
        width:664px;
        background-repeat:no-repeat;
        background-size:contain;
        background-image:url(${shapeSrc});
    }
    `
    }
`
const Content = styled.div`
overflow:hidden;
position:relative;
margin-top:15px;
background-repeat:no-repeat;
background-image:url(${mobBgImage});
background-size:1920px;
min-height:600px;
${
    media.desktop`
    background:none;
    `
    }
`
const TitleContainer = styled.div`
${
    media.desktop`
    position:relative;
    z-index:1;
    `
    }
`
const StyledTitle = styled(Title) `
color:${colors.white};
`
const YearDetailsContainer = styled.div`
margin:129px auto 10px;
width:90%;
height:80vh;
${
    media.desktop`
    height:500px;
    position:absolute;
    right:0;
    width:98%;
    max-width:1300px;
    `
    }
`
const ClockContainer = styled.div`
position:absolute;
top:0;
left:0;
right:0;
margin:0 auto;
transform:translate3d(0, 101px, 0) ${props => props.animate ? 'rotate(-80deg)' : ''};
transition:transform .6s;
will-change:transform;
z-index:3;
width:30px;

${
    media.desktop`
    width:400px;
    left:initial;
    transform:translate3d(-231px,423px,0);
    `
    }
`
const ClockHead = styled.div`
width:30px;
height:30px;
background-size:contain;
background-repeat:no-repeat;
background-image:url(${clockHead});

${
    media.desktop`
    width:83px;
    height:83px;
    transform:translate3d(10px,74px,0);
    `
    }
`
const ClockHand = styled.div`
position:absolute;
bottom:-60px;
left:0;
height:60px;
width:69px;
transform:translate3d(7px, -15px, 0) rotate(-90deg);
background-size:contain;
background-repeat:no-repeat;
background-image:url(${clockHand});
z-index:-1;

${
    media.desktop`
    transform:translate3d(27px,1px,0);
    width:337px;
    height:48px;
    left:initial;
    right:0;
    `
    }
`
const imageLessYears = [
    1949, 1957, 1958, 1966, 1967, 1975, 1983, 1984, 1988, 1993, 2009, 2012, 2016
];
class TimelineSection extends Component {
    constructor() {
        super();
        this.handleItemSelect = this.handleItemSelect.bind(this);
        this.state = {
            timelineItems: [],
            currentItem: {},
            animate: false
        }
    }

    componentDidMount() {
        this.setState({
            timelineItems: TimelineApi.getData()
        });
    }
    handleItemSelect(item, report) {
        this.setState({
            currentItem: item,
            hideItemsImage: imageLessYears.indexOf(Number(item.year)) > -1,
            animate: true
        });
        setTimeout(() => {
            this.setState({
                animate: false
            });
        }, 550);

        if (report)
            push('Years Navigation', item.year);
    }
    render() {
        const getCarousel = () => this.state.timelineItems.length ?
            <TimelineCarousel
                items={this.state.timelineItems}
                onItemSelect={this.handleItemSelect}
            /> : <div></div>

        return (
            <Container name="timeline">
                <ClockContainer animate={this.state.animate}>
                    <ClockHead />
                    <ClockHand animate={this.state.animate} />
                </ClockContainer>
                <TitleContainer>
                    <StyledTitle>גלגלים מקומיים</StyledTitle>
                    <Subtitle>שנה אחר שנה</Subtitle>
                </TitleContainer>
                <Content>
                    {getCarousel()}
                    <YearDetailsContainer>
                        <TimelineYearDetails
                            year={this.state.currentItem.year}
                            description={this.state.currentItem.description}
                            hideImage={this.state.hideItemsImage}
                        />
                    </YearDetailsContainer>
                </Content>
            </Container>
        )
    }
}

export default TimelineSection;


// WEBPACK FOOTER //
// ./src/containers/TimelineSection.jsx